import type { SearchableSelectOption } from "@/components/ui/SearchableSelect";

export type SupplierForSearchRow = {
  id: number;
  mv_supplier_id: number;
  mv_supplier_name: string | null;
  currency?: string | null;
  payment_terms?: string | null;
};

function supplierDisplayLabel(row: SupplierForSearchRow): string {
  const name = row.mv_supplier_name?.trim();
  if (name && name.length > 0) {
    return name;
  }
  return `Supplier #${row.id}`;
}

/** Map live supplier rows to SearchableSelect options; disambiguate duplicate names with MV id. */
export function supplierRowsToSearchableOptions(rows: SupplierForSearchRow[]): SearchableSelectOption[] {
  const labelCounts = new Map<string, number>();
  for (const row of rows) {
    const key = supplierDisplayLabel(row).toLowerCase();
    labelCounts.set(key, (labelCounts.get(key) ?? 0) + 1);
  }

  return rows.map((row) => {
    const label = supplierDisplayLabel(row);
    const duplicate = (labelCounts.get(label.toLowerCase()) ?? 0) > 1;
    return {
      value: String(row.id),
      label,
      description: duplicate ? `Megaventory supplier ${row.mv_supplier_id}` : null,
    };
  });
}
